/*
 * @Author: xushijie xushijie@yunlizhihui.com
 * @Date: 2023-02-08 15:06:29
 * @LastEditors: xushijie xushijie@yunlizhihui.com
 * @LastEditTime: 2023-02-10 12:55:00
 * @FilePath: \recognize_www\src\components\tinymce\tinymce.ts
 * @Description:
 *
 */
// ==========tinymce.js==========
// Any plugins you want to setting has to be imported
// Detail plugins list see https://www.tinymce.com/docs/plugins/
// Custom builds see https://www.tinymce.com/download/custom-builds/
// colorpicker/contextmenu/textcolor plugin is now built in to the core editor, please remove it from your editor configuration
// spellchecker
export const plugins = [
  "advlist image anchor autolink autosave code codesample  directionality  fullscreen hr insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace tabfocus  template  textpattern visualblocks visualchars wordcount",
];

export const toolbar = [
  "undo redo Upload lineheight fontsizeselect searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote removeformat subscript superscript codesample hr bullist numlist link anchor pagebreak  forecolor backcolor preview fullscreen code",
];

// fontsizeselect lineheight searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
// 'hr bullist numlist link  preview anchor pagebreak insertdatetime media  forecolor backcolor fullscreen

// export const toolbar = {
//   type: [String, Array],
//   default: `undo redo |  bold italic underline strikethrough |formatselect fontselect fontsizeselect |alignleft aligncenter alignright alignjustify | bullist numlist outdent indent lists| Upload fullscreen | forecolor backcolor |
//      searchreplace lineheight link table pagebreak code codesample
//        anchor charmap preview insertdatetime quickbars removeformat  subscript superscript selectall`,
// };
